import { render, staticRenderFns } from "./PriceManagement.vue?vue&type=template&id=6400738d&scoped=true"
import script from "./PriceManagement.vue?vue&type=script&lang=js"
export * from "./PriceManagement.vue?vue&type=script&lang=js"
import style0 from "./PriceManagement.vue?vue&type=style&index=0&id=6400738d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6400738d",
  null
  
)

export default component.exports